import { render, staticRenderFns } from "./FormAddress.component.vue?vue&type=template&id=4298185e&scoped=true&"
import script from "./FormAddress.component.vue?vue&type=script&lang=js&"
export * from "./FormAddress.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298185e",
  null
  
)

export default component.exports